
<template>
  <div class="list"   :class="$vuetify.theme.dark ? 'list-dark':''" v-if="item">
    <div class="row-group" @click.stop.prevent="(e)=>$emit('rowFun',e,item)" >
      <a href="/download/sap-windows.zip" download="sap-windows.zip" @click.stop="downLoadZip($event)" v-if="item.type == 36">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
                <img
                  src="@/assets/img/Slice161.png"
                  alt=""
                  class="down_style"
                  v-bind="attrs" v-on="on"
                >
          </template>
          <span>{{ $t("adhibition.downZip") }}</span>
        </v-tooltip>
      </a>
      <a href="/download/AutoLoginPlug.zip" download="AutoLoginPlug.zip" @click.stop="downLoadZip($event)" v-if="item.protocolType == 32">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <img
              src="@/assets/img/Slice161.png"
              alt=""
              class="down_style"
              v-bind="attrs" v-on="on"
            >
          </template>
          <span>{{ $t("adhibition.downZip") }}</span>
        </v-tooltip>
      </a>
      <v-img v-if="item.logoBase64" class="logo-pic" allow-overflow :src="'data:image/png;base64,'+item.logoBase64" ></v-img>
      <v-img v-else-if="item.logoUrl" class="logo-pic" allow-overflow :src="require('@/assets/img/'+ item.logoUrl)"></v-img>
      <v-img v-else class="logo-pic" allow-overflow src="@/assets/img/app-default-img.png"></v-img>


      <div class="label" :class="$vuetify.theme.dark ? '':'label-d'">
        <v-tooltip
          color="rgba(0, 0, 0, 0.75)"
          top
        >
          <template v-slot:activator="{ on, attrs }">
            <div
              color="primary"
              class="text_overflow"
              dark
              v-bind="attrs"
              v-on="on"
            >{{item.name}}</div>
          </template>
          <div>
            <div class="ant-tooltip-content"><div class="ant-tooltip-arrow"></div>
              <div role="tooltip" class="ant-tooltip-inner">
                <span>{{item.name}}</span>
              </div>
            </div>
          </div>
        </v-tooltip>
      </div>
      <div class="app-entrust-tip" v-if="item.isEntrustApp && item.isEntrustApp ==1">
        <img src="@/assets/img/entrust.png" />
      </div>
    </div>
  </div>


</template>

<script>

  import { mdiViewGridOutline } from '@mdi/js'

  export default {
    name:'app',
    props:{
        item:{
          type:Object,
          default:()=>null
        }

    },
    data() {
      return {
        icons: {

          mdiViewGridOutline
        },

      }

    },
    methods:{
      downLoadZip(e){
        e.stopPropagation()
      }
    }

  }



</script>


<style lang='scss' scoped>

  .list {
    // margin: 20px 27px;

    margin-left: 15px;
    margin-right: 15px;
    margin-bottom: 25px;
    margin-top:5px;
    width: 200px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    background: #FFFFFF;
    box-shadow: 0px 0px 3px 2px rgba(17, 18, 19, 0.08);
    border-radius: 12px;
    // border: 3px dashed transparent;
    cursor: pointer;
    position: relative;

    .row-group {

      height: 190px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;


      .logo-pic {
        width: 96px;
        max-height: 96px;
        border-radius: 15%;
      }

      .img {
        width: 47px;
      }

      .label {
        font-size: 14px;
        font-weight: 500;
        margin-top: 15px;
        width: 100%;
        padding: 0 20px;
        text-align: center;
        position: relative;
        z-index: 2;

        .text_overflow {
          width: 165px;
          text-align: center;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }
      }

      .label-d {
        color: #333333;
      }

      .add-label {
        margin-top: 35px;
        color: #2E6BF7;
      }
    }
    .down_style{
      position: absolute;
      top: 10px;
      right: 10px;
    }
  }

  .list:hover {
    box-shadow: 0px 1px 16px 3px rgba(17, 18, 19, 0.08);

  }
  .dragClass {
    cursor: move !important;

    .list{
      /*transform: scale(0.6);*/
      cursor: move !important;
      margin-left: -20px  !important;
      margin-bottom: 0px !important;
      margin-top: 10px !important;
      width: 100px !important;



      .row-group {
        height: 95px !important;
        justify-content: center !important;
        .logo-pic{
          width: 48px !important;
          max-height:  48px !important;

        }
          .down_style {
            opacity: 0;
          }

        .label {
          margin-top: 5px;
          padding:0px 5px !important;
          font-size: 12px !important;
          .text_overflow {
            width: 90px;
            text-align: center;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
          }
        }

      }
    }


  }
  .app-entrust-tip {
    position: absolute;
    bottom: -3px;
    right: -3px;
    z-index: 1;
    img {
      width: 36px;
      height: 36px;
    }
  }

</style>
